import './App.css';
import BlackbirdLanding from './BlackbirdLanding';

function App() {
  return (
    <div className="App">
      <BlackbirdLanding />
    </div>
  );
}

export default App;
